import Axios from "axios";
import {initUserForm} from "./form";
import {loading, stopLoading} from "../../helpers/loading";
import {handleAjaxSuccess} from "../../helpers/swalHelper";
import handleAjaxError from "../../helpers/handleAjaxError";
import {initForcePasswordChangeButton} from "./forcePasswordChange";

function initUsersEdit() {

	const userForm = initUserForm(document.querySelector('.user-form'));

	document.querySelector('.update-user-button').onclick = updateUser;

	initForcePasswordChangeButton(document.querySelector('.force-password-button'));

	function updateUser() {
		const userData = userForm.inputs();

		userForm.clearFeedbacks();

		loading();

		Axios.post(userForm.postUrl(), userData)
			.then(handleAjaxSuccess)
			.catch(handleAjaxError)
			.finally(stopLoading)
	}
}

export {initUsersEdit}
